import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { PieChart } from '@mui/x-charts/PieChart';
import '../../../Styles/topContentPieChart.scss';
import { useSelector } from 'react-redux';
import CircularProgress from "@mui/material/CircularProgress";
import { useDrawingArea } from '@mui/x-charts/hooks';
import { styled } from '@mui/material/styles';

const contentData = [
  { color: '#3db7a1' },
  { color: '#f2a65a' },
  { color: '#f36c91' },
  { color: '#7b72e9' },
  { color: '#f3c53d' },
];

const PieChartCenterTitle = styled('text')(({}) => ({
  textAnchor: 'middle',
  dominantBaseline: 'central',
  fontSize: 16,
  fontWeight: 400
}));

const PieChartCenterValue = styled('text')(({}) => ({
  textAnchor: 'middle',
  dominantBaseline: 'central',
  fontSize: 20,
  fontWeight: 600
}));

function PieCenterLabel({ children }) {
  const { width, height, left, top } = useDrawingArea();
  return (
    <>
      <PieChartCenterTitle x={left + width / 2} y={(top + height / 2) - 10 }>
        Total Views
      </PieChartCenterTitle>
      <PieChartCenterValue x={left + width / 2} y={(top + height / 2) + 15}>
        {children}
      </PieChartCenterValue>
    </>
  );
}

export default function TopContentPieChart() {

  const topContentViewsData = useSelector((state)=> state.topContentViews?.getTopContentViewsReq?.response);
  const topContentViewsLoading = useSelector((state)=> state.topContentViews?.isgetTopContentViewsLoading);
  if (topContentViewsLoading || !topContentViewsData) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CircularProgress size={34} /> 
      </div>
    );
  }
  const isEmptyData = topContentViewsData?.length === 0;

  return (
    <Box className="top-content-pie-chart">
      <div className='title-style'>
      <Typography variant="h6" className="title">
        Top 5 Content By Views
      </Typography>
      </div>
      <Box className="chart-and-table-container">
      {isEmptyData ? (
          <Box className="no-results-container">
            <Typography variant="h6" className="no-results-message">
              No results found
            </Typography>
          </Box>
        ) : (
          <>
        {/* Pie Chart */}
        <div className='box-style'>
        <Box className="pie-chart-container">
         
          <PieChart
            height={200}
            series={[
              {
                data: topContentViewsData?.map((item, index) => {
                  return {id: item?.title,

                  value: item?.views,
                  color: contentData[index]?.color,
                }
                })??[],
                innerRadius: 70,
                outerRadius: 100,
              },
            ]}
          >
            <PieCenterLabel>
              {topContentViewsData?.reduce((prev, e) => prev += parseInt(e.views), 0)}
            </PieCenterLabel>
          </PieChart>
         
        </Box>
        </div>

        {/* Table */}
        <Box className="table-container">
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Movie</th>
                <th>View Count</th>
              </tr>
            </thead>
            <tbody>
              {topContentViewsData.map((item, index) => (
               <tr key={index}>
                <td>
                <div className='colorList'
                   style={{
                     width: '10px',
                     height: '10px',
                     backgroundColor: contentData[index]?.color,
                     borderRadius: '4px',
                   }}
                 ></div>
                </td>
               <td style={{ display: 'flex',textAlign:"left", gap: '8px', width: '150px' }}>
                
                 {item?.title}
               </td> 
               <td>{item?.views}</td>
             </tr>
             
              ))}
            </tbody>
          </table>
        </Box>
        </>
        )}
      </Box>
          
    </Box>
          
  );
}
